import { useActiveMembership, type Membership } from '@/features/auth/session';

/** Every page and action this app gates, and the permissions each one needs.
 *  The only place a permission id is written — components ask for an action. */
export const ACCESS = {
  brandsPage: ['brand_hub:brand:view'],
  brandManage: ['brand_hub:brand:manage'],
  templatesPage: ['brand_hub:template:view'],
  templateCreate: ['brand_hub:template:edit'],
  templateUpdate: ['brand_hub:template:edit'],
  templateDelete: ['brand_hub:template:delete'],
  savedElementsPage: ['brand_hub:saved_element:view'],
  savedElementEdit: ['brand_hub:saved_element:edit'],
  savedElementDelete: ['brand_hub:saved_element:delete'],
} as const satisfies Record<string, readonly string[]>;

export type Action = keyof typeof ACCESS;

/** Whether one membership carries every permission an action needs.
 *  Role is no shortcut: the backend checks this same flat list. */
export function can(membership: Membership | null, action: Action | undefined): boolean {
  if (!action) return true;
  if (!membership) return false;
  return ACCESS[action].every((permission) => membership.permissions.includes(permission));
}

export function useCan(action: Action): boolean {
  return can(useActiveMembership(), action);
}
